import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
import { UnitPositionMapData } from '@/api/common/mapData'

const apiUrl = `${urlPrefix}/cruiseTrack`
//#region 基本信息
const GetList = `${apiUrl}`
const Get = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyCruiseTrack: CruiseTrackData = {
    Id: 0,
    CruiserId: 0,
    CruiserName: '',
    UnitCode: '',
    UnitName: '',
    UnitAddress: '',
    NewDate: new Date(),
    DetailList: [],

    UnitPositionAreas: []
}
export interface CruiseTrackData {
    [key: string]: any
    Id: number
    CruiserId: number
    CruiserName: string
    UnitCode: string
    UnitName: string
    UnitAddress: string
    NewDate: Date
    DetailList: CruiseTrackDetailData[]

    UnitPositionAreas: UnitPositionMapData[]
}

export interface CruiseTrackDetailData {
    [key: string]: any
    Id: number
    TrackId: number
    Longitude: number
    Latitude: number
    Address: string
    UserName: string
    NewDate: Date
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}
